import { supportsArrayBuffer, nativeIsView, toString } from "./_setup.js";
import isDataView from "./isDataView.js";
import constant from "./constant.js";
import isBufferLike from "./_isBufferLike.js";
var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function isTypedArray(obj) {
  return nativeIsView ? nativeIsView(obj) && !isDataView(obj) : isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
}
export default supportsArrayBuffer ? isTypedArray : constant(false);
